import { storage } from "./storage";

@storage()
export class AppStorage {
  token: string | null = null;
}

export const appStorage = new AppStorage();
